const myAlertsStyle = Object.freeze({
  buttonVariant: 'neutral',
});

export default myAlertsStyle;
